const locale = {
  RECEITA: 'Receita',
  DESPESA: 'Despesa',
};

export default locale;
